import classNames from 'classnames';
import Flex from 'components/common/Flex';
import IconButton from 'components/common/IconButton';
import React, { useState } from 'react';
import { Button, Card, Col, Form, Row } from 'react-bootstrap';
import ReactSelect from 'react-select';
import { numberTypeOptions } from './PhoneNumberInputs';

const emailObj = {
  id: 1,
  emailAddress: '',
  emailType: { value: 'personal', label: 'Personal' },
  isDefault: true
};

const EmailInputs = () => {
  const [emails, setEmails] = useState([{ ...emailObj }]);

  const handleInputChange = (e, id) => {
    const allEmails = [...emails];
    const selectedIndex = allEmails.findIndex(email => email.id === id);

    if (selectedIndex > -1) {
      const selectedEmail = allEmails[selectedIndex];
      selectedEmail.emailAddress = e.target.value.trimStart();
      setEmails(allEmails);
    }
  };

  const addEmailHandler = () => {
    const preEmails = [...emails];
    const newEmail = { ...emailObj };
    const lastAddressId = preEmails[preEmails.length - 1].id;
    newEmail.id = lastAddressId + 1;
    newEmail.isDefault = false;
    preEmails.push(newEmail);
    setEmails(preEmails);
  };

  const setAddDefaultEmail = id => {
    const allEmails = [...emails];
    const selectedIndex = allEmails.findIndex(email => email.id === id);
    const preDefaultIndex = allEmails.findIndex(email => email.isDefault);

    if (selectedIndex > -1 && !allEmails[selectedIndex].defaultAddress) {
      const preSelectedEmail = allEmails[preDefaultIndex];
      const selectedEmail = allEmails[selectedIndex];
      preSelectedEmail.isDefault = false;
      selectedEmail.isDefault = true;
      setEmails(allEmails);
    }
  };

  const changeEmailTypeHandler = (value, id) => {
    const allEmails = [...emails];
    const selectedIndex = allEmails.findIndex(email => email.id === id);
    if (selectedIndex > -1) {
      const selectedEmail = allEmails[selectedIndex];
      selectedEmail.emailType = value;
      setEmails(allEmails);
    }
  };

  const deletePhoneHandler = id => {
    const allPhoneNumbers = [...emails];
    const selectedIndex = allPhoneNumbers.findIndex(phone => phone.id === id);

    if (selectedIndex > -1) {
      allPhoneNumbers.splice(selectedIndex, 1);
      setEmails(allPhoneNumbers);
    }
  };

  return (
    <Card className="mb-3">
      <Card.Header>
        <Card.Title className="fw-medium">E-mail Address</Card.Title>
      </Card.Header>
      <Card.Body>
        <Row>
          {emails.map((item, index) => (
            <Col key={item.id} md={12}>
              <Form.Label>Email # {index + 1}</Form.Label>
              <Row className="g-3">
                <Form.Group as={Col} md={6} controlId="exampleFirstName">
                  <Form.Control
                    required
                    type="email"
                    placeholder="Enter your email please"
                    defaultValue=""
                    onChange={e => handleInputChange(e, item.id)}
                  />
                  <Form.Control.Feedback type="invalid">
                    Please provide a valid email address.
                  </Form.Control.Feedback>
                </Form.Group>
                <Form.Group as={Col} md={3}>
                  <ReactSelect
                    closeMenuOnSelect={true}
                    options={numberTypeOptions}
                    placeholder="Select"
                    classNamePrefix="react-select"
                    value={item.emailType}
                    onChange={value => changeEmailTypeHandler(value, item.id)}
                  />
                  <Form.Control.Feedback>Looks good!</Form.Control.Feedback>
                </Form.Group>

                <Col md={3}>
                  <Flex justifyContent="between">
                    <Form.Group controlId={`email-control-${item.id}`}>
                      <div className="mt-2">
                        <Form.Check
                          inline
                          type="radio"
                          name="emailInputs"
                          id={`email-control-${item.id}`}
                          value={`email-${item.id}`}
                          className="me-2"
                          defaultChecked={item.isDefault}
                          onClick={() => setAddDefaultEmail(item.id)}
                        />
                        <Form.Label className="mb-0">
                          {item.isDefault ? 'Primary' : ''}
                        </Form.Label>
                      </div>
                    </Form.Group>
                    <IconButton
                      variant="light"
                      icon="trash"
                      className={classNames(
                        'mb-1 bg-transparent border-0 shadow-none',
                        { 'v-hidden': item.isDefault }
                      )}
                      iconAlign="left"
                      transform="shrink-3"
                      iconClassName="text-danger me-2"
                      onClick={() => deletePhoneHandler(item.id)}
                      disabled={item.isDefault}
                    >
                      Delete
                    </IconButton>
                  </Flex>
                </Col>
              </Row>
              {index !== emails.length - 1 && <hr className="mb-2" />}
            </Col>
          ))}
        </Row>
      </Card.Body>
      <div className="p-3 pt-0">
        <Button
          variant="light"
          className="bg-transparent border-0 shadow-none fs--1 fs-md-0 text-primary p-1"
          onClick={addEmailHandler}
        >
          Add New Email
        </Button>
      </div>
    </Card>
  );
};

export default EmailInputs;
